import React, { useState } from 'react';
import './VideoTutorialPage.css';

const VideoTutorialPage = () => {
  const [activeTab, setActiveTab] = useState('public');

  return (
    <div className="video-tutorial-page">
      <div className="tabs">
        <button
          className={`tab ${activeTab === 'public' ? 'active' : ''}`}
          onClick={() => setActiveTab('public')}
        >
          Public Videos
        </button>
        <button
          className={`tab ${activeTab === 'member' ? 'active' : ''}`}
          onClick={() => setActiveTab('member')}
        >
          Members Only
        </button>
      </div>
      <div className="tab-content">
        {activeTab === 'public' && (
          <div>
            <h2>Public Videos</h2>
            <p>This is where the public videos will be displayed.</p>
          </div>
        )}
        {activeTab === 'member' && (
          <div>
            <h2>Member Exclusive Videos</h2>
            <p>This is where the member exclusive videos will be displayed.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoTutorialPage;
